import { useState, useEffect } from 'react';

interface HeaderProps {
  onCTAClick: () => void;
}

export default function Header({ onCTAClick }: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-900 shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
        <div className="flex flex-row items-center gap-2 sm:gap-3 flex-nowrap min-w-0">
          <img
            src="https://static.readdy.ai/image/b0e633acd2a0067190d43c4062b60336/91136b47557f9de47ddb28b4727f5299.jpeg"
            alt="プロジェクトマスター"
            className="h-7 sm:h-10 w-auto object-contain flex-shrink-0"
          />
          <span className="text-sm sm:text-xl font-bold whitespace-nowrap truncate text-white">
            プロジェクトマスター
          </span>
        </div>
        <button
          onClick={onCTAClick}
          className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold px-3 py-2 sm:px-8 sm:py-3 text-xs sm:text-base rounded-lg transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer flex-shrink-0"
        >
          今すぐ無料登録
        </button>
      </div>
    </header>
  );
}